import { css } from '@emotion/core'

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const buttonContainer = css`
  display: flex;
  justify-content: center;
`

export const signupButton = css`
  width: 50%;
`
